module.exports = __webpack_public_path__ + "static/colourconverter-df3f2717fbb091c8af66f12b8f966ec9.png";